import React from 'react';

function Main(props) {
    return (
        <div>ABOUT PAGE</div>
    );
  }

export default Main